import pickBy from 'lodash/pickBy'

const store = {
  namespaced: true,

  state: {
    drawers: [],
    left: false,
  },
  getters: {
    drawers: state => state.drawers,
    left: state => state.left,
  },
  mutations: {
    DRAWER_PUSH (state, options) {
      let attributes

      if (typeof options === 'object' && options.drawer) {
        attributes = pickBy(options, (value, key) => {
          return key !== 'drawer' || key !== 'mixins'
        })
      }

      state.left = options.left || false

      state.drawers.splice(0, 1)

      state.drawers.push({
        component: options.drawer || options,
        attributes,
      })
    },
    DRAWER_CLOSE (state) {
      state.drawers = []
    },
  },
  actions: {
    load ({ commit }, component) {
      commit('DRAWER_PUSH', component)
    },
    open ({ commit }, options) {
      document.body.classList.add('u-no-scroll')

      commit('DRAWER_PUSH', options)
    },
    close ({ commit }) {
      document.body.classList.remove('u-no-scroll')

      commit('DRAWER_CLOSE')
    },
  },
}

export default store
